import {
  HTMLProps,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { orderData, OrderHeaderType } from '../TableTestdata';
import {
  ColumnDef,
  Row,
  RowData,
  SortingState,
  TableMeta,
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  getGroupedRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import * as Styled from '../TableStyled';
import TableConfig from '../TableConfig';
import { useHeaderButtons } from '../../header/HeaderButtonProvider';
import SquareButton from '../../button/SquareButton';
import { AiFillCaretRight } from 'react-icons/ai';
import { AiFillCaretDown } from 'react-icons/ai';
import ListTooltip from '../../common/ListTooltip';
import { ValueWithKey } from '../TableTestdata';
import { traderData } from '../TableTestdata';
import TraderUploadModal from '../../common/modal/ModalComponents/TraderUploadModal';
import axios from 'axios';
import { useTheme } from 'styled-components';
import { toast } from 'react-hot-toast';
import { IoMdArrowDropdown, IoMdArrowUp } from 'react-icons/io';
import { IoMdArrowDropup } from 'react-icons/io';
import { BsArrowDown } from 'react-icons/bs';
import { BsArrowUp } from 'react-icons/bs';
import { BsArrowDownUp } from 'react-icons/bs';

import {
  keyMapping,
  orderListGetApi,
  orderListPostApi,
  OrderUploadResponseType,
  productionBetweenDaysGetApi,
  ProductionSimpleType,
  ProductItem,
  traderListGetApi,
  traderListPostApi,
  TraderType,
  WorkbayType,
} from '../../../api/apiConfig';
import useFetch from '../../../api/useFetch';
import { OrderUploadModal } from '../../common/modal/ModalComponents/OrderUploadModal';
//주문번호 예시 20241104-1

import { BsChevronDoubleLeft } from 'react-icons/bs';
import { BsChevronDoubleRight } from 'react-icons/bs';
import { BsChevronLeft } from 'react-icons/bs';
import { BsChevronRight } from 'react-icons/bs';

import {
  OrderListType,
  OrderListUpdateRequestDto,
} from '../../../api/apiConfig';
import { PaginationState } from '../Pagination';
import {
  formatCurrency,
  formatDashFormToEightDigitString,
  formatEightDigitStringToDashForm,
  formatEightDigitStringToSlashForm,
  getYearMonthDateFromDate,
} from '../../../function/replaceString';
import { groupOrderWithItemSubrow } from '../../../function/initData';
import { workbayIdToName } from '../../../@const/mapper';

type ProductionTableProps = {
  periodStartDate: string;
  periodEndDate: string;
  itemGruopOption: 'none' | 'daily' | 'all';
  selectedItemList: ProductItem[];
  selectedWorkbay?: WorkbayType;
};

export const ProductionTable = ({
  periodStartDate,
  periodEndDate,
  itemGruopOption,
  selectedItemList,
  selectedWorkbay,
}: ProductionTableProps) => {
  const theme = useTheme();

  const [productionOriginData, setProductionOriginData] = useState<
    ProductionSimpleType[]
  >([]);

  const [productionData, setProductionData] = useState<ProductionSimpleType[]>(
    []
  );

  const [sorting, setSorting] = useState<SortingState>([]);

  const { fetch: fetchProductionBetweenDaysGetApi } = useFetch({
    fetchFunction: productionBetweenDaysGetApi,
    onSuccess: (data: ProductionSimpleType[]) => {
      setProductionOriginData(data);
      sortProductionData(data);
    },
  });

  useEffect(() => {
    fetchProductionBetweenDaysGetApi({
      startDate: formatDashFormToEightDigitString(periodStartDate),
      endDate: formatDashFormToEightDigitString(periodEndDate),
    });
  }, [periodStartDate, periodEndDate]);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const [showModal, setShowModal] = useState<boolean>(false);

  const [modalType, setModalType] = useState<'edit' | 'add' | null>(null);

  //테이블 옵션값 ~~~
  const [headerOverflowType, setHeaderOverflowType] = useState<'wrap' | 'hide'>(
    'hide'
  );
  const [bodyOverflowType, setBodyOverflowType] = useState<'wrap' | 'hide'>(
    'hide'
  );
  const [bodyAlignHoriType, setBodyAlignHoriType] = useState<
    'left' | 'center' | 'right'
  >('center');

  const [cellHoriPaddValue, setCellHoriPaddValue] = useState<number>(5);
  const [bodyVertPaddValue, setBodyVertPaddValue] = useState<number>(5);

  const [showConfig, setShowConfig] = useState<boolean>(false);

  const columns = useMemo<ColumnDef<ProductionSimpleType>[]>(
    () => [
      {
        header: ({ table }) => <>No</>,
        cell: ({ row, getValue }) => (
          <Styled.NoBodyCell style={{ paddingLeft: `${row.depth * 2}rem` }}>
            <Styled.NoText>{row.index + 1}</Styled.NoText>
          </Styled.NoBodyCell>
        ),
        id: 'NO',
        size: 60,
      },
      {
        header: '품목명',
        accessorKey: 'prodDes',
        size: 280,
      },
      {
        header: '규격명',
        accessorKey: 'sizeDes',
        size: 265,
      },
      {
        header: '생산수량',
        accessorKey: 'qty',
        size: 80,
      },
      {
        header: '목표수량',
        accessorKey: 'productionGoal',
        size: 80,
      },
      {
        header: '생산일자',
        accessorKey: 'productionDt',
        size: 125,
        cell: (productionDt) =>
          formatEightDigitStringToDashForm(productionDt.getValue() as string),
      },
      {
        header: '작업장',
        accessorKey: 'workbayId',
        size: 140,
        cell: (workbayId) => workbayIdToName(workbayId.getValue() as number),
      },
    ],
    []
  );

  function sortProductionData(data?: ProductionSimpleType[]) {
    const applyItemFilter = selectedItemList.length > 0;
    const applyWorkbayFilter =
      selectedWorkbay !== undefined && selectedWorkbay.id !== -1;
    let dataArray: ProductionSimpleType[] = [];
    if (applyItemFilter || applyWorkbayFilter) {
      let filteredArray: ProductionSimpleType[] = data || productionOriginData;

      if (applyItemFilter) {
        filteredArray = filteredArray.filter((item) =>
          selectedItemList.some(
            (selectedItem) => selectedItem.id === item.itemId
          )
        );
      }
      if (applyWorkbayFilter) {
        filteredArray = filteredArray.filter(
          (item) => item.workbayId === selectedWorkbay.id
        );
      }
      dataArray = filteredArray;
    } else {
      dataArray = data || productionOriginData;
    }
    let sortedDataArray: ProductionSimpleType[] = [];
    // itemGruopOption 값에 따라 처리
    if (itemGruopOption === 'none') {
      setProductionData(dataArray);
      return;
    } else if (itemGruopOption === 'daily') {
      // 이미 존재하는 데이터를 기준으로 필터링/정렬 처리
      sortedDataArray = dataArray.reduce(
        (acc: ProductionSimpleType[], production) => {
          // 기존에 같은 itemId를 가진 데이터가 있는지 확인
          const existingItem = acc.find(
            (sortedData: ProductionSimpleType) =>
              sortedData.itemId === production.itemId &&
              sortedData.productionDt === production.productionDt &&
              sortedData.workbayId === production.workbayId
          );

          if (existingItem) {
            existingItem.productionGoal += production.productionGoal;
            existingItem.qty += production.productionGoal;
          } else {
            // 없으면 해당 아이템을 추가
            acc.push(production);
          }

          return acc;
        },
        []
      ); // 빈 배열을 초기값으로 설정
    } else if (itemGruopOption === 'all') {
      // 이미 존재하는 데이터를 기준으로 필터링/정렬 처리
      sortedDataArray = dataArray.reduce(
        (acc: ProductionSimpleType[], production) => {
          // 기존에 같은 itemId를 가진 데이터가 있는지 확인
          const existingItem = acc.find(
            (sortedData: ProductionSimpleType) =>
              sortedData.itemId === production.itemId &&
              sortedData.workbayId === production.workbayId
          );

          if (existingItem) {
            existingItem.productionGoal += production.productionGoal;
            existingItem.qty += production.productionGoal;
          } else {
            // 없으면 해당 아이템을 추가
            acc.push(production);
          }

          return acc;
        },
        []
      ); // 빈 배열을 초기값으로 설정
    }
    setProductionData(sortedDataArray);
  }

  useEffect(() => {
    sortProductionData();
  }, [itemGruopOption, selectedItemList, selectedWorkbay]);

  //아마 페이지네이션
  function useSkipper() {
    const shouldSkipRef = useRef(true);
    const shouldSkip = shouldSkipRef.current;

    // Wrap a function with this to skip a pagination reset temporarily
    const skip = useCallback(() => {
      shouldSkipRef.current = false;
    }, []);

    useEffect(() => {
      shouldSkipRef.current = true;
    });

    return [shouldSkip, skip] as const;
  }

  const [autoResetPageIndex, skipAutoResetPageIndex] = useSkipper();
  //~~페이지네이션

  const table = useReactTable({
    data: productionData,
    columns,
    columnResizeMode: 'onChange',
    state: {
      expanded: true,
      pagination,
      sorting,
    },
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getGroupedRowModel: getGroupedRowModel(),
    autoResetPageIndex,
    getPaginationRowModel: getPaginationRowModel(),
    paginateExpandedRows: false,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
  });

  const columnSizeVars = useMemo(() => {
    const headers = table.getFlatHeaders();
    const colSizes: { [key: string]: number } = {};
    for (let i = 0; i < headers.length; i++) {
      const header = headers[i]!;
      colSizes[`--header-${header.id}-size`] = header.getSize();
      colSizes[`--col-${header.column.id}-size`] = header.column.getSize();
    }
    return colSizes;
  }, [table.getState().columnSizingInfo, table.getState().columnSizing]);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Styled.PaginationButtonContainer>
          <Styled.PaginationButton
            size={28}
            onClick={() => table.firstPage()}
            disabled={!table.getCanPreviousPage()}
          >
            <BsChevronDoubleLeft />
          </Styled.PaginationButton>
          <Styled.PaginationButton
            size={28}
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            <BsChevronLeft />
          </Styled.PaginationButton>
          {/* 중간인풋 */}
          <Styled.PaginationButton
            size={28}
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            <BsChevronRight />
          </Styled.PaginationButton>
          <Styled.PaginationButton
            size={28}
            onClick={() => table.lastPage()}
            disabled={!table.getCanNextPage()}
          >
            <BsChevronDoubleRight />
          </Styled.PaginationButton>
        </Styled.PaginationButtonContainer>
        <div
          style={{
            alignContent: 'center',
            marginLeft: '20px',
            marginRight: '40px',
          }}
        >
          {table.getPageCount()}페이지 중{' '}
          {table.getState().pagination.pageIndex + 1}페이지
        </div>
        <div className='flex-center'>페이지당 표시 데이터 수</div>
        <select
          id={'row-count'}
          value={pagination.pageSize}
          onChange={(e) => {
            setPagination((prev) => ({
              pageIndex: prev.pageIndex,
              pageSize: Number(e.target.value),
            }));
            table.firstPage();
          }}
          style={{ marginLeft: '14px' }}
        >
          <option key={'10'} value={10}>
            10개
          </option>
          <option key={'20'} value={20}>
            20개
          </option>
          <option key={'30'} value={30}>
            30개
          </option>
          <option key={'40'} value={40}>
            40개
          </option>
          <option key={'50'} value={50}>
            50개
          </option>
        </select>
      </div>

      <Styled.TableContainer>
        <Styled.TableOptionButton onClick={() => setShowConfig(!showConfig)}>
          설정
        </Styled.TableOptionButton>
        <TableConfig
          show={showConfig}
          Header_Overflow_Type={headerOverflowType}
          setHeaderOverflowType={(value: 'hide' | 'wrap') =>
            setHeaderOverflowType(value)
          }
          Body_Overflow_Type={bodyOverflowType}
          setBodyOverflowType={(value: 'hide' | 'wrap') =>
            setBodyOverflowType(value)
          }
          Body_Align_Hori_Type={bodyAlignHoriType}
          setBodyAlignHoriType={(value: 'left' | 'center' | 'right') =>
            setBodyAlignHoriType(value)
          }
          Cell_Hori_Padd_Value={cellHoriPaddValue}
          setCellHoriPaddValue={(value: number) => setCellHoriPaddValue(value)}
          Body_Vert_Padd_Value={bodyVertPaddValue}
          setBodyVertPaddValue={(value: number) => setBodyVertPaddValue(value)}
        />
        <Styled.TableDiv
          {...{
            style: {
              ...columnSizeVars,
              width: table.getTotalSize(),
            },
          }}
          $headOverflowType={headerOverflowType}
          $bodyOverflowType={bodyOverflowType}
          $bodyAlignHoriType={bodyAlignHoriType}
          $cellHoriPaddValue={cellHoriPaddValue}
          $bodyVertPaddValue={bodyVertPaddValue}
        >
          {table.getHeaderGroups().map((headerGroup) => {
            return (
              <Styled.ThDiv {...{ key: headerGroup.id }}>
                {headerGroup.headers.map((headerCell) =>
                  headerCell.isPlaceholder ? null : (
                    <Styled.ThCell
                      {...{
                        key: headerCell.id,
                        style: {
                          width: `calc(var(--header-${headerCell?.id}-size) * 1px)`,
                          cursor: headerCell.column.getCanSort()
                            ? 'pointer'
                            : 'auto',
                        },
                        // headerCell.column.getCanSort()

                        onClick: headerCell.column.getToggleSortingHandler(),
                        className: 'th',
                      }}
                    >
                      {headerCell.isPlaceholder
                        ? null
                        : flexRender(
                            headerCell.column.columnDef.header,
                            headerCell.getContext()
                          )}

                      {headerCell.column.getIsSorted() === 'asc' && (
                        <BsArrowDown size={14} style={{ marginLeft: '5px' }} />
                      )}
                      {headerCell.column.getIsSorted() === 'desc' && (
                        <BsArrowUp size={14} style={{ marginLeft: '5px' }} />
                      )}
                      {!headerCell.column.getIsSorted() &&
                        headerCell.column.getCanSort() && (
                          <BsArrowDownUp
                            size={14}
                            style={{ marginLeft: '5px' }}
                          />
                        )}

                      <Styled.ResizeHandler
                        {...{
                          onMouseDown: headerCell.getResizeHandler(),
                          className: `resizer ${
                            headerCell.column.getIsResizing()
                              ? 'isResizing'
                              : ''
                          }`,
                        }}
                      />
                    </Styled.ThCell>
                  )
                )}
              </Styled.ThDiv>
            );
          })}
          {table.getRowModel().rows.map((row) => (
            <>
              <Styled.TdDiv
                {...{
                  key: row.id,
                }}
              >
                {row.getVisibleCells().map((cell) => {
                  const isMainRow = row.depth === 0;

                  // 커스텀 스타일 (변경된 셀에 하이라이트 적용)
                  return (
                    <Styled.TdCell
                      {...{
                        key: cell.id,
                        className: 'td',
                        style: {
                          // 해당 셀이 변경되었으면 배경 색을 노란색으로 하이라이트
                          backgroundColor: isMainRow
                            ? theme.colors.white_odd
                            : 'transparent',
                          width: `calc(var(--header-${cell.column.id}-size) * 1px)`, // 셀 크기
                        },
                      }}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </Styled.TdCell>
                  );
                })}
              </Styled.TdDiv>
            </>
          ))}
        </Styled.TableDiv>
      </Styled.TableContainer>
    </>
  );
};
